<template>
  <v-app>
    <v-container fill-height fluid class="pa-0">
      <v-row class="fill-height">
        <v-col cols="12" class="hidden-sm-and-down landing-welcome">
          <LogoAnimated />
        </v-col>
        <v-navigation-drawer
          :v-model="true"
          class="pa-10 pt-4"
          :right="true"
          permanent
          width="400"
          overlay-opacity="0"
          fixed
        >
          <LangSelector/>
          <h1 v-if="form == 'RegistrationForm'">{{ $t('landing.signup') }}</h1>
          <h1 v-else>{{ $t('landing.login') }}</h1>
          <component :is="form" />
          <div
            class="text-center mt-6 primary--text"
            @click="form == 'RegistrationForm' ? form = 'LoginForm' : form = 'RegistrationForm' "
          >
            <span v-if="form == 'RegistrationForm'">{{ $t('forms.registered') }}</span>
            <!-- <span v-else>{{ $t('forms.newAccount') }}</span>-->
            
          </div>
          <div @click="routeTo('register')" class="text-center mt-6 primary--text pointer">
            <span>{{ $t('forms.newDistributor') }}</span>
            </div>
        </v-navigation-drawer>
      </v-row>



    </v-container>
  </v-app>
</template>

<script>
//import gql from 'graphql-tag'
import LangSelector from "../components/LangSelector";
import LogoAnimated from "../components/LogoAnimated";
import RegistrationForm from "../components/AuthForms/RegistrationForm.vue";
import LoginForm from "../components/AuthForms/LoginForm.vue";

export default {
  name: "Welcome",
  components: {
    LogoAnimated,
    RegistrationForm,
    LoginForm,
    LangSelector
  },
  data() {
    return {
      form: 'LoginForm',
      fixed: false,
    };
  },
  methods: {
    routeTo(val){
      this.$router.push(val)
    }
  }
  /*
  async mounted () {
        this.loading = true
        this.users = await this.$apollo.query({ query: GetHello })
        this.loading = false
  }
  */
  // Simple query that will update the 'hello' vue property
    //hello: gql`{hello}`,
};
</script>

<style scoped>
.landing-welcome {
  background-image: url('../assets/img/landing-bcg.jpg');
  background-position: top top;
  background-repeat: repeat-y;
  background-attachment: fixed;
  background-size: contain;
  background-color: white;
}
</style>
